import React, {createContext, useContext, useEffect, useState} from 'react';

const MyContext = createContext();

const MyContextProvider = ({ children,triggerData  }) => {
  const [data, setData] = useState();

  const updateData = (newDate) => {
    setData(newDate);
  };

  useEffect(() => {
    triggerData(data)
  }, [data]);
  return (
      <MyContext.Provider value={{ data, updateData }}>
        {children}
      </MyContext.Provider>
  );
};

const useMyContext = () => {
  const context = useContext(MyContext);
  if (!context) {
    throw new Error('useMyContext must be used within a MyContextProvider');
  }
  return context;
};

export { MyContextProvider, useMyContext };
